import { API_URL } from '../../../app-config/constants';
import { DeleteRequest } from '../../react/features/Admin/DeleteCompanyPage/types';
import { get, post } from '../request';

const BASE_URL = `${API_URL}/delete-company`;

export function deleteCompany(request: DeleteRequest): Promise<void> {
    return post(BASE_URL, { postData: request });
}

export function getDeleteCompanyPermissions(): Promise<{ canDeleteCompany: boolean; reason: string | null }> {
    return get(`${BASE_URL}/permissions`);
}
